import { render, staticRenderFns } from "./CaracteristicaSaude.vue?vue&type=template&id=05369def"
import script from "./CaracteristicaSaude.vue?vue&type=script&lang=js"
export * from "./CaracteristicaSaude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports